if (!customElements.get('ceq-config-summary-box')) {
  customElements.define(
    'ceq-config-summary-box',
    class CeqConfigSummaryBox extends HTMLElement {
      constructor() {
        super();

        this.updateSummaryBox(true);
      }

      fetchSummaryBox(qty, price) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const sectionUrl = `${rootUrl}?section_id=ceq-config-summary-box`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.classList.add('shown');
            this.innerHTML = sectionInnerHTML.outerHTML;

            this.updateData(qty, price);
          })
          .catch((e) => {
            console.error('fetchSummaryBox', e);
          });
      }

      parsePrice(priceString) {
        if (!priceString) {
          console.error('Price string is empty or undefined');
          return NaN; // Return NaN (Not-a-Number) if price string is empty or undefined
        }
        
        // Extract numeric value from the price string
        var numericValue = priceString.replace(/[^\d.,]/g, '').replace(',', '.');
        
        // Convert the string to a number
        var parsedPrice = parseFloat(numericValue).toFixed(2);
        
        // Check if the parsed value is a valid number
        if (isNaN(parsedPrice)) {
          console.error('Failed to parse price:', priceString);
          return NaN; // Return NaN if parsing failed
        }
        
        return parsedPrice;
      }

      updateData(qty, price) {
        this.querySelector('b.qty').innerText = qty;
        this.querySelector('b.price').innerText = price;
      }

      updateSummaryBox(shouldFetch) {       
        if (window.location.href.indexOf('/build-your-gym/') !== -1) {
          let summaryData = JSON.parse(sessionStorage.getItem("ceq_config_summary"));
          if( summaryData ) {
            if( shouldFetch ) {
              this.fetchSummaryBox(summaryData.qty, summaryData.price);
            } else {
              const box = this.querySelector('.ceq-config-summary-box__wrapper');
              if( box ) {
                this.updateData(summaryData.qty, summaryData.price);
              } else {
                this.fetchSummaryBox(summaryData.qty, summaryData.price);
              }
            }
          }
        }
      }

      updateStorage(qty, price) {
        let summaryData = JSON.parse(sessionStorage.getItem("ceq_config_summary"));
        if (!summaryData) {
          summaryData = {
            qty: 0,
            price: 0
          };
        }
        
        let summary = {
          qty: summaryData.qty + qty,
          price: (parseFloat(summaryData.price) + (qty * price)).toFixed(2)
        };
  
        sessionStorage.setItem("ceq_config_summary", JSON.stringify(summary));
      }
      
    }
  );
}
